import { classNames } from "../../classNames";

export type Tone = "success" | "info" | "warning" | "danger" | "neutral";

const STATUS_TONES: Record<string, Tone> = {
  Active: "success",
  Enabled: "success",
  Paid: "success",
  Approved: "success",
  Completed: "success",
  Current: "success",
  Prospect: "info",
  "In progress": "info",
  New: "info",
  Invited: "info",
  "At risk": "warning",
  Pending: "warning",
  Locked: "warning",
  "Expiring soon": "warning",
  "In review": "warning",
  Expired: "danger",
  Rejected: "danger",
  Disabled: "neutral",
  Inactive: "neutral",
  Draft: "neutral",
  Archived: "neutral",
};

export interface BadgeProps {
  label: string;
  tone?: Tone;
  /** Leading dot (default true for status tones, false for neutral labels). */
  dot?: boolean;
  mono?: boolean;
  outline?: boolean;
  title?: string;
}

/** Status is always spelled out (never color alone). */
export function Badge({ label, tone, dot, mono, outline, title }: BadgeProps): React.JSX.Element {
  const resolved = tone ?? STATUS_TONES[label] ?? "neutral";
  const withDot = dot ?? (!outline && resolved !== "neutral");
  const classes = classNames("nb-badge", outline ? "nb-badge-outline" : `nb-badge-${resolved}`, withDot ? "nb-badge-dot" : null, mono ? "nb-badge-mono" : null);
  return (
    <span className={classes} title={title}>
      {label}
    </span>
  );
}
